export const Types = {
  RESET_DATA: "resultCenter/RESET_DATA",
  GET_ALL_RESULT_CENTER: "resultCenter/GET_ALL_RESULT_CENTER",
  GET_ALL_RESULT_CENTER_SUCCESS: "resultCenter/GET_ALL_RESULT_CENTER_SUCCESS",
  GET_ALL_RESULT_CENTER_ERROR: "resultCenter/GET_ALL_RESULT_CENTER_ERROR",
  SET_IS_LOADING_LIST: "resultCenter/SET_IS_LOADING_LIST",
  SHOW_HIDE_RESULT_CENTER_FORM: "resultCenter/SHOW_HIDE_RESULT_CENTER_FORM",
  SET_IS_LOADING_FORM: "resultCenter/SET_IS_LOADING_FORM",
  SHOW_HIDE_FINANCIAL_NATURE_APPORTIONMENT_FORM: "resultCenter/SHOW_HIDE_RESULT_CENTER_APPORTIONMENT_FORM",
  SET_IS_LOADING_APPORTIONMENT_FORM: "resultCenter/SET_IS_LOADING_APPORTIONMENT_FORM",
  EXPAND_OR_COMPACT_APPORTIONMENT_FORM: "resultCenter/EXPAND_OR_COMPACT_APPORTIONMENT_FORM",
  INACTIVATE_RESULT_CENTER: "resultCenter/INACTIVATE_RESULT_CENTER",
  ACTIVATE_RESULT_CENTER: "resultCenter/ACTIVATE_RESULT_CENTER",
  MAKE_STANDARD_RESULT_CENTER: "resultCenter/MAKE_STANDARD_RESULT_CENTER",
};

export const Creators = {
  index: (
    groupId,
    farmId,
  ) => ({
    type: Types.GET_ALL_RESULT_CENTER,
    payload: {
      groupId,
      farmId
    },
  }),
  indexSuccess: (data) => ({
    type: Types.GET_ALL_RESULT_CENTER_SUCCESS,
    payload: {
      data,
    },
  }),
  indexError: (error) => ({
    type: Types.GET_ALL_RESULT_CENTER_ERROR,
    payload: {
      error,
    },
  }),
  setIsLoadingList: (isLoading = false) => ({
    type: Types.SET_IS_LOADING_LIST,
    payload: {
      isLoading
    },
  }),
  showOrHideForm: (id = null) => ({
    type: Types.SHOW_HIDE_RESULT_CENTER_FORM,
    payload: {
      id
    },
  }),
  setIsLoadingForm: (isLoading = false) => ({
    type: Types.SET_IS_LOADING_FORM,
    payload: {
      isLoading
    },
  }),
  showOrHideFinancialNatureApportionmentForm: (id = null) => ({
    type: Types.SHOW_HIDE_FINANCIAL_NATURE_APPORTIONMENT_FORM,
    payload: {
      id
    },
  }),
  setIsLoadingApportionmentForm: (isLoading = false) => ({
    type: Types.SET_IS_LOADING_APPORTIONMENT_FORM,
    payload: {
      isLoading
    },
  }),
  expandOrCompactApportionmentForm: () => ({
    type: Types.EXPAND_OR_COMPACT_APPORTIONMENT_FORM,
  }),
  inactivateResultCenter: (groupId, farmId, id) => ({
    type: Types.INACTIVATE_RESULT_CENTER,
    payload: {
      groupId,
      farmId,
      id,
    },
  }),
  activateResultCenter: (groupId, farmId, id) => ({
    type: Types.ACTIVATE_RESULT_CENTER,
    payload: {
      groupId,
      farmId,
      id,
    },
  }),
  makeStandardResultCenter: (groupId, farmId, id) => ({
    type: Types.MAKE_STANDARD_RESULT_CENTER,
    payload: {
      groupId,
      farmId,
      id,
    },
  }),
};

const INITIAL_STATE = {
  resultCenterList: [],
  isResultCenterFormVisible: false,
  isFinancialNatureApportionmentFormVisible: false,
  resultCenterId: null,
  isLoadingList: false,
  isLoadingForm: false,
  isLoadingApportionmentForm: false,
  error: {},
  isApportionmentFormExpanded: false,
};

export default function resultCenter(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.RESET_DATA:
      return INITIAL_STATE;
    case Types.GET_ALL_RESULT_CENTER:
      return {
        ...state,
        isLoadingList: true,
      };
    case Types.GET_ALL_RESULT_CENTER_SUCCESS:
      const { data: list } = action.payload;
      return { ...state, isLoadingList: false, resultCenterList: list };
    case Types.GET_ALL_RESULT_CENTER_ERROR:
      const { error } = action.payload;
      return {
        ...state,
        isLoadingList: false,
        resultCenterList: null,
        error,
      };
    case Types.SET_IS_LOADING_LIST:
      return { ...state, isLoadingList: action.payload.isLoading };
    case Types.SHOW_HIDE_RESULT_CENTER_FORM:
      return { ...state, resultCenterId: action.payload.id, isResultCenterFormVisible: !state.isResultCenterFormVisible };
    case Types.SET_IS_LOADING_FORM:
      return { ...state, isLoadingForm: action.payload.isLoading };
    case Types.SHOW_HIDE_FINANCIAL_NATURE_APPORTIONMENT_FORM:
      return { ...state, resultCenterId: action.payload.id, isFinancialNatureApportionmentFormVisible: !state.isFinancialNatureApportionmentFormVisible };
    case Types.SET_IS_LOADING_APPORTIONMENT_FORM:
      return { ...state, isLoadingApportionmentForm: action.payload.isLoading };
    case Types.EXPAND_OR_COMPACT_APPORTIONMENT_FORM:
      return { ...state, isApportionmentFormExpanded: !state.isApportionmentFormExpanded };
    case Types.INACTIVATE_RESULT_CENTER:
      return { ...state, isLoadingList: true };
    case Types.ACTIVATE_RESULT_CENTER:
      return { ...state, isLoadingList: true };
    case Types.MAKE_STANDARD_RESULT_CENTER:
      return { ...state, isLoadingList: true };
    default:
      return state;
  }
}
